module.exports = __webpack_public_path__ + "media/images/emblems/Andeer_wappen-8699ab51510ddde193fc3af2c64c2648.svg";